import React from "react";
import { motion } from "framer-motion";

const POINTS = [
  {
    num: "01",
    title: "Fast Turnaround",
    desc: "Tight programmes, crews on-site fast. We hit dates and hand sites over ready for the next trade.",
  },
  {
    num: "02",
    title: "Clean & Organised",
    desc: "Dust sheeting, floor protection and daily clear-downs. You'd never know we were there.",
  },
  {
    num: "03",
    title: "Reliable & Professional",
    desc: "In-house PAYE crews, supervised by a site manager. No chancers, no no-shows — just the same faces every day.",
  },
  {
    num: "04",
    title: "Residential & Commercial",
    desc: "From a single flat to multi-floor City offices — our kit and crews scale to your site.",
  },
  {
    num: "05",
    title: "End-to-End",
    desc: "Every project is handed over ready for follow-on trades — or delivered right through to snag-free handover.",
  },
];

export default function WhyUs() {
  return (
    <section
      id="why-us"
      data-testid="why-us-section"
      className="bg-[#F5EFE5] text-[#2B2420] py-20 md:py-28"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5">
            <span className="brand-gold-divider" /> Why Constantinov
          </div>
          <h2
            className="font-black tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            Built on dates, dust sheets <br /> and discipline.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10">
          {POINTS.map((p, i) => (
            <motion.div
              key={p.num}
              data-testid={`why-us-point-${p.num}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              className="flex gap-5 md:gap-7 border-t border-[#2B2420]/10 pt-7"
            >
              <div
                className="shrink-0 font-black text-[#B8732C] leading-none text-5xl md:text-6xl"
                style={{ fontFamily: "Cabinet Grotesk" }}
              >
                {p.num}
              </div>
              <div>
                <h3
                  className="font-black tracking-tight text-2xl md:text-3xl"
                  style={{ fontFamily: "Cabinet Grotesk" }}
                >
                  {p.title}
                </h3>
                <p className="mt-2.5 text-[#8A7F74] leading-relaxed max-w-md">{p.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
